import React from "react";
import PropTypes from "prop-types";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const propTypes = {
  currentPage: PropTypes.number,
};

const SkeletonProducts = ({ currentPage }) => {
  return (
    <SkeletonTheme height={38}>
      <div className="mb-4">
        <Skeleton width="20%" height={25} />
      </div>
      {currentPage < 2 && (
        <>
          <div className="row mb-3 mb-lg-5">
            <div className="col-4 mb-3 mb-lg-0">
              <Skeleton />
            </div>
            <div className="col-4 mb-3 mb-lg-0">
              <Skeleton />
            </div>
            <div className="col-4 mb-3 mb-lg-0">
              <Skeleton />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <Skeleton />
            </div>
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <Skeleton />
            </div>
            <div className="col-12 col-lg-3 mb-3 mb-lg-0">
              <Skeleton />
            </div>
            <div className="col-12 col-lg-1 mb-3 mb-lg-0">
              <Skeleton className="button" />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <Skeleton width="50%" />
            </div>
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <Skeleton width="70%" />
            </div>
            <div className="col-12 col-lg-4 mb-3 mb-lg-0">
              <Skeleton width="50%" className="lang" />
            </div>
          </div>
        </>
      )}

      <div className="row">
        {[...Array(8)].map((num, i) => (
          <div key={i} id={num} className="col-12 col-lg-3 mb-4">
            <div className="img">
              <Skeleton className="mb-2" height={200} />
            </div>
            <div className="info">
              <Skeleton className="mb-2" width="50%" height={20} />
              <Skeleton className="mb-2" width="75%" height={20} />
              <Skeleton className="mb-2" width="25%" height={20} />
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

SkeletonProducts.propTypes = propTypes;

export default SkeletonProducts;
